import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../mock";

export default function FAQPage() {
  const [open, setOpen] = useState(0);
  return (
    <div className="bg-[#f4f0e6] text-[#3a3a32] min-h-screen">
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-20">
        <p className="text-xs tracking-[0.4em] uppercase text-[#4a7ba1] mb-4 text-center">Frequently asked</p>
        <h1 className="text-4xl md:text-6xl font-light text-center leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Answers, before you ask.</h1>

        <div className="mt-16 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border border-[#4a7ba1]/20 rounded-sm bg-[#ece6d6]/40 overflow-hidden">
                <button
                  className="w-full flex items-center justify-between text-left px-6 py-5 hover:bg-[#ece6d6] transition-colors"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className="text-lg md:text-xl text-[#1e3a52]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{f.q}</span>
                  <ChevronDown size={20} className={`text-[#4a7ba1] flex-shrink-0 ml-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-[#5a5a52] leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
